import { render, staticRenderFns } from "./RolesCrud.vue?vue&type=template&id=3643fec2&scoped=true"
import script from "./RolesCrud.vue?vue&type=script&lang=js"
export * from "./RolesCrud.vue?vue&type=script&lang=js"
import style0 from "./RolesCrud.vue?vue&type=style&index=0&id=3643fec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643fec2",
  null
  
)

export default component.exports